<div class="wrap-hero">
  <app-header></app-header>
  <!-- <app-hero></app-hero> -->
</div>
<div class="mt-7">
  <app-main-gallery></app-main-gallery>
</div>

<app-coverage-summary></app-coverage-summary>
<!-- <app-featured-insurance> </app-featured-insurance> -->
<!-- <app-action-call></app-action-call> -->
<app-footer></app-footer>
